export const CATEGORY_OPTIONS = [{id:'GoTravelRes', name:'GoTravelRes'}, {id:'Priority', name:'Priority'}]